import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";

const Counter = (props) => {
  const [contador, setContador] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
        setContador(prev => {
            return prev >= parseInt(props.limit) ? 0 : prev + 1
        });
    }, 1000); // Cada 1000ms = 1 segundo

    // Limpiar el intervalo cuando se desmonte el componente
    return () => clearInterval(intervalo);
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h3>Esta pantalla se refrescará a los {props.limit} segundos</h3>
      <h2>{contador}</h2>
    </div>
  );
};

Counter.propTypes = {
    limit: PropTypes.number
}

export default Counter